import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  image: string
  description: string
}

const Item = ({ image, description }: Props) => {
  return (
    <Box gap="s8" maxWidth="s200" textAlign="center">
      <img src={image} alt={description} height="140" />
      <Text.Normal color="grey800" weight="normal" size="200">
        {description}
      </Text.Normal>
    </Box>
  )
}

export default observer(Item)
